import { FC } from 'react';
import styled, { css } from 'styled-components';

import Text from '@/components/Text';
import { ChannelGroupResource } from '@/types/resources';

const Box = styled.div<{ $isWhite?: boolean }>`
  background-color: ${({ theme }) => theme.colors.grayscaleSuperLight};
  padding: 20px 16px;
  border: solid 1px ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  ${({ theme, $isWhite }) =>
    $isWhite &&
    css`
      background: ${theme.colors.white};
    `}
`;

const HeadingHolder = styled.div`
  display: flex;
  gap: 8px;
  svg {
    transform: translateY(4px);
    flex-shrink: 0;
  }
`;

const Heading = styled(Text)`
  span {
    color: ${({ theme }) => theme.colors.gray};
  }
`;

const Channels = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 22px;
`;

const Channel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ChannelIcon = styled.img`
  width: 16px;
  height: 16px;
  object-fit: contain;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  background-color: #ecbe19;
`;

interface Props {
  currentGroup?: ChannelGroupResource;
  isWhite?: boolean;
}

const ChannelsList: FC<Props> = ({ currentGroup, isWhite }) => {
  return (
    <Box $isWhite={isWhite}>
      <HeadingHolder>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="7.5" fill="#E9E9E9" stroke="#E9E9E9" />
          <path
            d="M7.25 5.73529V4.5H8.75V5.73529H7.25ZM7.25 11.5V6.55882H8.75V11.5H7.25Z"
            fill="#222222"
          />
        </svg>
        <Heading $type="captionSemibold">
          Pages List of <span>({currentGroup?.name})</span>
        </Heading>
      </HeadingHolder>
      {!!currentGroup?.channels?.length && (
        <Channels>
          {currentGroup.channels.map((channel) => (
            <Channel key={channel.id}>
              {!!channel.thumbnail && (
                <ChannelIcon
                  src={channel.thumbnail}
                  alt={`${channel.name} icon`}
                />
              )}
              <Text as="span" $type="smallBold">
                {channel.name}
              </Text>
            </Channel>
          ))}
        </Channels>
      )}
    </Box>
  );
};

export default ChannelsList;
